import React, { useEffect, useRef, useState } from "react";

import { pdfjs } from "react-pdf";

import PdfPreview from "../../../../PdfPreview";
import { buildCoaPreviewPayload, fetchCoaPreviewPdf } from "../../../coaPreviewHelper";
import "./builderPreview.css";
import "./coaPreview.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

export default function BuilderPreview({
  inputs,
  isCustomizingCoa,
  setLoadingPreview,
  uniqueTests,
  enableTests,
  side,
  templateId,
  coaName,
}) {
  const [pdfUrl, setPdfUrl] = useState("");
  const [pdfError, setPdfError] = useState(false);
  const abortRef = useRef(null);

  useEffect(() => {
    if (!inputs) {
      return undefined;
    }

    const values = Object.values(inputs).filter((input) => input?.length > 0);
    const hasData = values.length > 1;
    if (!hasData) {
      setLoadingPreview(false);
      return undefined;
    }

    if (abortRef.current) {
      abortRef.current.abort();
    }
    const controller = new AbortController();
    abortRef.current = controller;

    const loadPreview = async () => {
      setLoadingPreview(true);
      setPdfError(false);
      try {
        const previewPayload = buildCoaPreviewPayload({
          builderPayload: inputs,
          side,
          templateId,
          uploadToS3: false,
          uniqueTests,
          enableTests,
          isCustomizingCoa,
          isTemplateSave: !isCustomizingCoa,
          logoImageUrl: inputs.logo_image_url,
          signatureImageUrl: inputs.signature_image_url,
          coaName: undefined,
        });
        const { blob, canceled } = await fetchCoaPreviewPdf(previewPayload, controller.signal);
        if (canceled || controller.signal.aborted || !blob) {
          return;
        }
        const url = URL.createObjectURL(blob);
        setPdfUrl((prev) => {
          if (prev) {
            URL.revokeObjectURL(prev);
          }
          return url;
        });
      } catch (error) {
        if (!controller.signal.aborted) {
          setPdfError(true);
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoadingPreview(false);
        }
      }
    };

    loadPreview();

    return () => {
      controller.abort();
    };
  }, [inputs, side, templateId, uniqueTests, enableTests, isCustomizingCoa, setLoadingPreview]);

  useEffect(() => () => {
    if (pdfUrl) {
      URL.revokeObjectURL(pdfUrl);
    }
  }, [pdfUrl]);

  const values = Object.values(inputs || {}).filter((input) => input?.length > 0);
  const hasData = values.length > 1;
  if (!hasData) {
    return (
      <div className="builderPreviewSection">
        Add your details in edit mode to customize the COA.
      </div>
    );
  }

  return (
    <div className={`BuilderPreviewContainer ${isCustomizingCoa ? "BuilderPreviewContainer--customizingCoa" : ""}`}>
      <PdfPreview
        blob={pdfUrl}
        height="78vh"
        scaleType={isCustomizingCoa ? undefined : "PageWidth"}
        showLoading={!pdfUrl}
        showError={pdfError}
      />
    </div>
  );
}
